"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCalenderMatrixOfMonth = void 0;
const typeChecker_1 = require("./typeChecker");
function isValidDate(date) {
    return (0, typeChecker_1.isDate)(date) && !isNaN(date.valueOf());
}
const generateCalenderMatrixOfMonth = (input) => {
    if (!isValidDate(input))
        throw new Error('Invalid Date');
    const calendar = [];
    const currentDate = new Date(input);
    currentDate.setDate(1); // 주어진 날짜의 월의 첫 번째 날로 설정
    let firstDayOfWeek = currentDate.getDay();
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    let row = Array(7).fill(null);
    for (let day = 1; day <= lastDayOfMonth; day++) {
        row[firstDayOfWeek] = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
        if (firstDayOfWeek === 6 || day === lastDayOfMonth) {
            calendar.push(row);
            row = Array(7).fill(null);
        }
        firstDayOfWeek = (firstDayOfWeek + 1) % 7;
    }
    return calendar;
};
exports.generateCalenderMatrixOfMonth = generateCalenderMatrixOfMonth;
